import { animate, stagger } from 'motion'
import ease from '@/utils/ease'
import { getLenis } from '@/lib/lenis'
import { getSwup } from '@/lib/swup'

export default () => ({
	background: 'transparent',
	isScrolled: false,
	isAbout: false,
	lastScrollY: 0,

	init() {
		this.onRouteChange()

		this.onRouteChange = this.onRouteChange.bind(this)

		this.setupRouteListener()
		this.animateUnderline()
		this.animateMenuLinks()
		this.setupHomeLogoScroll()
	},

	animateUnderline() {
		const underline = this.$el.querySelector('[data-header-underline]')
		if (!underline) return
		const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
		animate(
			underline,
			{ scaleX: 1 },
			{ duration: reduced ? 0 : 0.35, delay: reduced ? 0 : 0.2, easing: ease.inOutQuint },
		)
	},

	animateMenuLinks() {
		const menuLinks = this.$el.querySelectorAll('[data-header-menu-link]')
		if (!menuLinks) return
		const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
		animate(
			menuLinks,
			{ opacity: 1 },
			{
				duration: reduced ? 0 : 0.35,
				delay: reduced ? 0 : stagger(0.075, { startDelay: 0.2 }),
				easing: ease.inOutQuint,
			},
		)
	},

	onRouteChange() {
		const path = window.location.pathname
		this.isScrolled = false

		this.isAbout = path === '/'
	},

	setupRouteListener() {
		if (typeof window === 'undefined') return

		getSwup()?.hooks.on('content:replace', this.onRouteChange)
	},

	setupHomeLogoScroll() {
		const homeLogos = document.querySelectorAll('[data-home-logo]')
		if (!homeLogos?.length) return

		homeLogos.forEach((logo) => {
			logo.addEventListener('click', (e) => {
				const isHomePage = window.location.pathname === '/'
				if (isHomePage) {
					e.preventDefault()
					getLenis()?.scrollTo(0, {
						duration: 1,
						immediate: false,
						lock: true,
					})
				}
			})
		})
	},

	destroy() {
		if (typeof window === 'undefined') return

		getSwup()?.hooks.off('content:replace', this.onRouteChange)
	},
})
